import {
  Alert,
  type AlertProps,
  AlertTitle,
  Button,
  Container,
  type ContainerProps,
  Stack,
} from "@mui/material";
import {
  ALERT_SEVERITY_MAP,
  getAlertTypeConfig,
  type PitstopAlertType,
} from "features/PitstopAlerts/pitstopAlertDefs";

export function PitstopAlertDisplay({
  id,
  title,
  description,
  alertType,
  linkHref,
  linkText,
  onClose,
  alertProps,
  containerProps,
}: {
  id: string;
  title: string;
  description: string | null | undefined;
  alertType: PitstopAlertType;
  linkHref?: string | null | undefined;
  linkText?: string | null | undefined;
  onClose?: (id: string) => void;
  alertProps?: AlertProps;
  containerProps?: ContainerProps;
}) {
  const config = getAlertTypeConfig(alertType);
  const severity = ALERT_SEVERITY_MAP[alertType] ?? "info";
  return (
    <Container {...containerProps}>
      <Alert
        severity={severity}
        icon={config?.icon ?? undefined}
        onClose={() => {
          onClose?.(id);
        }}
        {...alertProps}
      >
        <AlertTitle gutterBottom={Boolean(description)}>{title}</AlertTitle>
        {description}
        {linkHref && (
          <Stack direction="row" mt={1}>
            <Button
              component="a"
              href={linkHref}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              size="small"
              color="inherit"
            >
              {linkText || linkHref}
            </Button>
          </Stack>
        )}
      </Alert>
    </Container>
  );
}
